<template>
  <div :id="data.id" class="bg-gray-lighten3 pb-20 md:pb-28">
    <component
      :is="isDesktop ? CategoryFeaturesBlocks : CategoryFeaturesBlocksMobile"
      :items="items"
    ></component>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useBreakpoint, useMediaAsset } from '~/composables';
import CategoryFeaturesBlocks from '~/components/sections/categorySection/CategoryFeaturesBlocks.vue';
import CategoryFeaturesBlocksMobile from '~/components/sections/categorySection/CategoryFeaturesBlocksMobile.vue';

interface Props {
  data?: { id?: string; items: any[] };
}

const props = withDefaults(defineProps<Props>(), {
  data: () => ({ items: [] }),
});

const { getAssetUrl } = useMediaAsset();
const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');

const items = computed(() =>
  props.data?.items?.map((item: any) => ({
    ...item,
    image: getAssetUrl(item.image),
  })),
);
</script>
